import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { createMetaManager } from 'vue-meta';
import { hydrateFrontendTheme } from './utils/frontend-theme';
import './styles';
import axiosInstance from './services/axios'; // Import the instance
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { useWishlistStore } from './stores/wishlistStore';
import { useCartStore } from './stores/useCartStore';

hydrateFrontendTheme();

const app = createApp(App);
app.use(createMetaManager());
const pinia = createPinia();
app.use(router);
app.use(pinia);
useWishlistStore().initializeWishlistProducts();
useCartStore().initializeCartProducts();

app.use(Vue3Toastify, { autoClose: 3000 });

// Make the Axios instance available globally
app.config.globalProperties.$axios = axiosInstance;
app.config.globalProperties.$siteURL = process.env.VUE_APP_SITE_URL || 'http://localhost:8080/';

app.mount('#app');